import {Injectable} from "@angular/core";
import * as firebase from "firebase";
import {Platform} from "ionic-angular";
import {HttpClient, HttpHeaders, HttpParams} from "@angular/common/http";
import {GlobalProvider} from "../global/global";
import {AngularFirestore} from '@angular/fire/firestore';

@Injectable()
export class PwaProvider {
  private messaging;
  private unsubscribeOnTokenRefresh = () => {
  };
  headers: any;

  constructor(
    private platform: Platform,
    private http: HttpClient,
    private global: GlobalProvider,
    private afs: AngularFirestore
  ) {
    this.headers = new HttpHeaders().set("Content-Type", "application/json").set('Access-Control-Allow-Origin', '*');

    this.messaging = firebase.messaging();
    navigator.serviceWorker.register("service-worker.js").then(registration => {
      this.messaging.useServiceWorker(registration);
    });
  }

  public enableNotifications(idUsuario) {
    if (!Notification) {
      console.log('Este navegador no soporta notificaciones');
      return;
    }

    if (this.messaging.permission === 'granted') {
      new Notification("Hola Mundo -- granted")
    } else {
      return this.messaging.requestPermission().then(() => {
        return this.updateToken(idUsuario);
      });

    }
  }

  public disableNotifications() {
    this.unsubscribeOnTokenRefresh();
    this.unsubscribeOnTokenRefresh = () => {
    };
  }

  private updateToken(idUsuario) {
    const devicesRef = this.afs.collection("devices");

    return this.messaging.getToken().then(currentToken => {
      if (currentToken) {
        // we've got the token from Firebase, now let's store it in the database
        console.log("token: ", currentToken);
        let datos = {
          tipo: "pwa-" + this.platform.platforms()[1],
          uuid: "mobileweb",
          token: currentToken,
          idempleado: idUsuario
        };

        let url = this.global.URLBASEJSON + "registrar-instalacion";

        let params = new HttpParams();
        params = params.append("tipo", datos.tipo);
        params = params.append("uuid", datos.uuid);
        params = params.append("token", datos.token);
        params = params.append("idempleado", datos.idempleado);

        console.log(datos.tipo);
        console.log(datos.uuid);
        console.log(datos.token);
        console.log(datos.idempleado);

        this.http.post(url, params, this.headers).subscribe(data => {
          console.log('respuesta bd:', data);
          return devicesRef.doc(data['instalacion'].id.toString()).set(datos);
        });
      } else {
        console.log(
          "No Instance ID token available. Request permission to generate one."
        );
      }
    });
  }

}



// WEBPACK FOOTER //
// ./src/providers/pwa/pwa.ts